export default __webpack_public_path__ + "static/media/strasbourg20.6bb4d96a.jpg";